import { CACHE_VERSION } from "./constants";

export interface CacheSnapshotChannels {
    [channelId: string]: any[];
}

export interface CacheSnapshotRules {
    [ruleName: string]: string;
}

export interface CacheSnapshot {
    /** Primary key: `${layoutId}|${hash}|${cloneTransformHash}`. */
    signature: string;
    layoutId: string;
    /** Layout payload hash; secondary-indexed for hash-takeover lookup. */
    hash: string;
    layout: any;
    font_urls?: any[];
    clone_transform?: any;
    /** Per-container clone transforms (clone_pages containers). */
    clone_transforms?: any[];
    clone_transform_hash?: string;
    channels: CacheSnapshotChannels;
    rules: CacheSnapshotRules;
    schemaVersion: number;
    snapshotTs: number;
    snapshotTtlMs: number;
}

export function buildSignature(layoutId: string, hash: string | null | undefined, cloneTransformHash: string | null | undefined): string {
    return `${layoutId}|${hash ?? ""}|${cloneTransformHash ?? ""}`;
}

/* see docs/EXTRACTED_COMMENTS.md#c318 */
export function hashCloneTransforms(transforms: any[] | null | undefined): string {
    if (!transforms || transforms.length === 0) return "";
    const norm = transforms
        .map((t) => ({
            c: t?.container_id ?? "",
            m: (t?.channel_map || [])
                .map((cm: any) => `${cm?.source}>${cm?.dest}`)
                .sort(),
        }))
        .sort((a, b) => (a.c < b.c ? -1 : a.c > b.c ? 1 : 0));
    return JSON.stringify(norm);
}

/* see docs/EXTRACTED_COMMENTS.md#c319 */
export function combinedCloneHash(rootHash: string | null | undefined, transforms: any[] | null | undefined): string | null {
    const ch = hashCloneTransforms(transforms);
    if (!ch) return rootHash ?? null;
    return `${rootHash ?? ""}~${ch}`;
}

export function isSnapshotExpired(snap: CacheSnapshot, now: number = Date.now()): boolean {
    return now - snap.snapshotTs > snap.snapshotTtlMs;
}

export function isSnapshotCompatible(snap: CacheSnapshot): boolean {
    return snap.schemaVersion === CACHE_VERSION;
}
